// Vendor
import * as React from 'react';

// Internal
import { Image } from '@src/components/Image/Image';
import { DEFAULT_SAL_PROPS, SAL_DELAY } from '@src/config/sal';
import { SlideReveal } from '@src/components/SlideReveal/SlideReveal';

const ThriftOffsetsWaste: React.FC = () => {
  return (
    <div className="tup-slide">
      <h1 {...DEFAULT_SAL_PROPS} className="max-w-xl">
        Thrift Offsets Wastefulness of Single-Use Fashion
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-3 md:gap-24 mt-8">
        <div className="col-span-2">
          <p
            {...DEFAULT_SAL_PROPS}
            data-sal-delay={SAL_DELAY * 1}
            className="tup-description"
          >
            NUMBER OF OUTFITS FOR EACH OCCASION THAT SHOPPERS ONLY WORE ONCE
            <sup>2</sup>
          </p>
          <SlideReveal>
            <Image
              alt="Single Use Outfits Chart"
              className="mt-4"
              fileName="4b-chart.png"
            />
          </SlideReveal>
        </div>
        <div
          {...DEFAULT_SAL_PROPS}
          data-sal="fade"
          data-sal-delay={SAL_DELAY * 2}
          className="text-center p-4 mt-8 md:mt-0"
        >
          <p className="pr-4 pl-4 mb-4">
            If everyone wore a thrifted outfit to a wedding next year, it would
            save <b>1.6B lbs</b> of CO2e.
          </p>
          <Image alt="Wedding Outfit icon" fileName="4b-wedding-outfit.png" />
          <p className="pr-2 pl-2 mt-4">
            That’s the equivalent of taking <b>56M cars off the road</b> for a
            day.<sup>6</sup>
          </p>
        </div>
      </div>
      <div
        {...DEFAULT_SAL_PROPS}
        data-sal="fade"
        data-sal-delay={SAL_DELAY * 2}
        className="bg-brand-background p-6 pl-12 pr-12 mt-8"
      >
        <h2 {...DEFAULT_SAL_PROPS} data-sal-delay={SAL_DELAY * 2}>
          The Environmental Cost of Single Use<sup>6</sup>
        </h2>
        <div className="flex flex-wrap justify-around items-baseline mt-4">
          <div
            {...DEFAULT_SAL_PROPS}
            data-sal-delay={SAL_DELAY * 3}
            className="text-center mb-8"
          >
            <p>
              <span className="tup-number font-bold">1 in 2</span>
              <br />
              shoppers say they don’t want to <br />
              be seen in the same outfit twice.
            </p>
          </div>
          <div
            {...DEFAULT_SAL_PROPS}
            data-sal-delay={SAL_DELAY * 4}
            className="text-center mb-8"
          >
            <p>
              <span className="tup-number font-bold">70%</span>
              <br />
              of shoppers say they have
              <br /> purchased a single-use outfit.
            </p>
          </div>
          <div
            {...DEFAULT_SAL_PROPS}
            data-sal-delay={SAL_DELAY * 5}
            className="text-center"
          >
            <p>
              <span className="tup-number font-bold">208M</span>
              <br />
              lbs of waste were generated by
              <br /> single-use outfits in 2019.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export { ThriftOffsetsWaste };
